<template>
  <div class="sidebar-box mt-6 p-1">
    <h6 class="mb-3 p-2 cursor-pointer" data-toggle="collapse" data-target="#feature-filter">
      {{ $t('filter.feature.title') }}
      <i class="bi bi-arrow-down-circle"></i>
    </h6>

    <div id="feature-filter" :class="{'show':collapseOpen}" class="collapse p-2">
      <template v-for="feature in featuresObject">

        <div class="my-2" v-if="feature.feature_attributes.length > 0">
          <label class="cursor-pointer" data-toggle="collapse" :data-target="`#feature-filter-${feature.id}`"
                 data-v-68ac1b1a="">{{ feature.name }}</label>
          <i class="bi bi-chevron-left mr-1 text-dark" data-toggle="collapse"
             :data-target="`#feature-filter-${feature.id}`"></i>
        </div>


        <div class="collapse feature-height mr-2" :id="`feature-filter-${feature.id}`">
          <div class="form-group form-check" v-for="featureAttribute in feature.feature_attributes">
            <input v-model="selectedFeature" :value="featureAttribute" name="filter_features"
                   type="checkbox"
                   class="form-check-input" :id="`feature_filter_${featureAttribute.id}`">
            <label class="form-check-label mr-3" :for="`feature_filter_${featureAttribute.id}`">
              {{ featureAttribute.value }}
            </label>
          </div>
        </div>

      </template>

    </div>


  </div>
</template>

<script>
export default {
  name: "FilterFeature1",
  props: {
    featureColumn: {
      default: 'id',
      validator(value) {
        // The value must match one of these strings
        return ['id'].includes(value)
      }
    },
    collapseOpen: {
      type: Boolean,
      default: false
    },
    featuresObject: {
      default: []
    },
  },
  data() {
    return {
      selectedFeature: [],
    }
  },
  async mounted() {
  },
  methods: {
    getFeatureIds() {
      const ids = this.selectedFeature.map(item => {
        return item.id
      });
      return ids.length > 0 ? ids : null
    },
    filterOutput() {
      if (this.featureColumn === 'id') {
        return this.getFeatureIds();
      }
    }
  },
  watch: {
    selectedFeature: {
      handler() {
        this.$emit('featuresObject', this.selectedFeature)
        this.$emit('features', this.filterOutput())
      }
    }
  }
}
</script>

<style scoped>

.sidebar-box {
  border-radius: 10px;
  background: white;
  box-shadow: 0px 5px 25px rgba(218, 211, 211, 0.3);
  margin-bottom: 30px;
  border: 1px solid #F5F4F4;
}

.feature-height {
  max-height: 360px;
  overflow-y: auto;
}

.cursor-pointer {
  cursor: pointer;
}
</style>